import React from 'react';
import { connect } from 'react-redux';
import { Helpers } from '../../core/src/helpers';

import { fetchBV } from '../bv-actions';

class BvReviews extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.scriptLoaded && this.props.product.sku) {
            fetchBV(this.props.product.sku);
        }
    }

    render() {
        const { sku } = this.props.product;

        const transformedSKU = sku ? Helpers.BVTransformSKU(this.props.product.sku) : '';
        return (
            <div itemScope itemType="https://schema.org/Product" className="bv-reviews">
                <div data-bv-show="questions" data-bv-product-id={transformedSKU}></div>
                <div data-bv-show="review_highlights" data-bv-product-id={transformedSKU}></div>
                <div data-bv-show="reviews" data-bv-product-id={transformedSKU}></div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { scriptLoader } = state;
    return { scriptLoaded: scriptLoader['bv'] };
};

export default connect(mapStateToProps, null)(BvReviews);
